import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListItemText from "@material-ui/core/ListItemText";
import Checkbox from "@material-ui/core/Checkbox";
import Avatar from "@material-ui/core/Avatar";
import { Typography } from "@material-ui/core";
import Colors from "../../constants/Colors";

const styles = theme => ({
  root: {
    width: "100%",
    maxWidth: 300,
    backgroundColor: theme.palette.background.paper
  },
  leftContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-start"
  },
  rightContainer: {
    display: "flex",
    marginLeft: 20,
    flex: 1,
    alignItems: "center",
    justifyContent: "flex-end"
  },
  points: {
    color: Colors.main,
    fontWeight: 500
  }
});

const RankingComponent = ({ ranking, classes, hasPicture }) => {
  return (
    <div className={classes.root}>
      <List>
        {ranking.map((value, index) => (
          <ListItem key={index} dense button>
            <div className={classes.leftContainer}>
              <ListItemText primary={index + 1} />
              <Avatar
                alt={value.name || `${value.firstName} ${value.lastName}`}
                src={hasPicture ? value.picture : ""}
              />
              <ListItemText
                primary={value.name || `${value.firstName} ${value.lastName}`}
              />
            </div>
            <div className={classes.rightContainer}>
              <Typography classes={{ root: classes.points }}>
                {value.points || value.experience || 0}
              </Typography>
            </div>
          </ListItem>
        ))}
      </List>
    </div>
  );
};

export default withStyles(styles)(RankingComponent);
